import { CardTypes, AllMarketTypes } from '../enums';

export const getCardColor = (cardType) => {
  switch (CardTypes[cardType]) {
    case CardTypes[1]:
    case CardTypes[3]:
    case CardTypes[5]:
    case CardTypes[7]:
    case CardTypes[9]:
    case CardTypes[11]:
    case CardTypes[13]:
    case CardTypes[15]:
    case CardTypes[17]:
    case CardTypes[19]:
    case CardTypes[21]:
    case CardTypes[23]:
      return AllMarketTypes.Red;
    case CardTypes[2]:
    case CardTypes[4]:
    case CardTypes[6]:
    case CardTypes[8]:
    case CardTypes[10]:
    case CardTypes[12]:
    case CardTypes[14]:
    case CardTypes[16]:
    case CardTypes[18]:
    case CardTypes[20]:
    case CardTypes[22]:
    case CardTypes[24]:
      return AllMarketTypes.Black;
    default:
      return null;
  }
};
